export default __webpack_public_path__ + "static/teamwork_logo_word-7f2b02a09653c972fd5a9e80ea6abbf2.svg";